export default __webpack_public_path__ + "static/media/339.d445ec0e.png";